<template>
  <div :class="$style.sectionManage">
    <div class="container">
      <div class="manage-container">
        <img class="manage-bg" src="@assets/dingbeauty-images/home/background01@1.png" alt="" />
        <div class="manage-content">
          <h1>專屬打造</h1>
          <h1 class="bottom">你的美業好夥伴</h1>
          <p>Ding Beauty 讓您擁有</p>
          <p class="text-offest">「品牌專屬預約網站」及「完整雲端管理系統」</p>
          <p>美業預約管理需要的</p>
          <p>我們都幫您準備好了</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" module>
$color-primary: #d8b37f;

.sectionManage {
  :global {
    .manage-container {
      position: relative;
      height: 300px;
      color: $color-primary;
      margin-top: 80px;

      .manage-bg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .manage-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        text-align: center;

        h1 {
          font-size: 30px;

          &.bottom {
            margin-bottom: 24px;
          }
        }

        p {
          color: $color-text-2;
          font-size: 14px;
          margin-bottom: 4px;
        }

        .text-offest {
          margin-bottom: 28px;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .sectionManage {
    :global {
      .manage-container {
        height: 600px;

        .manage-bg {
        }

        .manage-content {
          h1 {
            font-size: 40px;

            &.bottom {
              margin-bottom: 2rem;
            }
          }

          p {
            font-size: 16px;
            margin-bottom: 4px;
          }

          .text-offest {
            margin-bottom: 32px;
          }
        }
      }
    }
  }
}
</style>
